/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calm_Gold_Slug_LandInputs */

const en_calm_gold_slug_land = /** @type {(inputs: Calm_Gold_Slug_LandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legacy`)
};

const de_calm_gold_slug_land = /** @type {(inputs: Calm_Gold_Slug_LandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legacy`)
};

/**
* | output |
* | --- |
* | "Legacy" |
*
* @param {Calm_Gold_Slug_LandInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const calm_gold_slug_land = /** @type {((inputs?: Calm_Gold_Slug_LandInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calm_Gold_Slug_LandInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calm_gold_slug_land(inputs)
	return de_calm_gold_slug_land(inputs)
});